module.exports = __webpack_public_path__ + "img/3-5.b4cc76b5.png";